import ReactGA from 'react-ga4';
import { Autocomplete, TextField } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import OfferContext from '../../store/OfferContext';
import CurrencyContext from "../../store/CurrencyContext";
import { useTranslation } from "react-i18next";

const DataSelector = () => {
    const offerCtx = useContext(OfferContext)
    const currencyCtx = useContext(CurrencyContext)
    const selectedCapacity = offerCtx.selectedCapacity;
    const [options, setOptions] = useState([])
    const [defaultCapacity, setDefaultCapacity] = useState(null)
    const [value, setValue] = useState(null)
    const { t } = useTranslation('common');

    const handleChange = (_event, value) => {
        setValue(value)

        //Two cases: case 1 we send the value of the option (value.value) - case 2 we send value which is null
        if (value) {
            offerCtx.changeCapacity(value.value)
        } else {
            offerCtx.changeCapacity(value)
        }
        offerCtx.changeCountries(offerCtx.selectedCountries)

        // Track the data selection change event
        ReactGA.event({
            category: 'data_capacity_selection',
            action: 'change_data_capacity',
            label: value ? value.label : 'None'
        });
    }

    const extractCountries = (serializedString) => {
        const countriesRegex = /"([^"]*)"/g;
        const matches = serializedString.match(countriesRegex);
        if (matches) {
            // Filter out the empty strings and remove the surrounding /"/"
            return matches.map(country => country.replace(/"/g, ''));
        }
    
        return [];
    }

    useEffect(() => {
        if (selectedCapacity === null){
            setValue(null);
        }
    }, [selectedCapacity])

    useEffect(() => {
        const selectedCountries = offerCtx.selectedCountries;

        const filteredList = offerCtx.data.filter((offer) => {
            // Parse the serialized countries string into an array
            if (offer.countries){
                const extractedCountries = extractCountries(offer.countries)
                // Check if any of the selected countries are included in the parsed array
                return selectedCountries.every(countryCode => extractedCountries.includes(countryCode));
            }

            return false
        });

        if (filteredList.length > 0) {
            setDefaultCapacity(filteredList[0].dataAmount)
        }
        
        //Using set to get the unique values
        let filteredCapacity = Array.from(new Set(filteredList.map(offer => offer.dataAmount)))
        
        // Filter out negative values
        filteredCapacity = filteredCapacity.filter(capacity => capacity >= 0)
        
        filteredCapacity.sort((a, b) => {
            return a - b
        })

        //Adding a value and option to the option to have a translated 
        const optionsWithLabel = filteredCapacity.map(
            (option) => {
                if (currencyCtx.languageParentWindow === "fr") {
                    const label = option < 1000 ? option + " Mo" : (option / 1000) + " Go"
                    return {
                        label: label,
                        value: option
                    }
                } else {
                    const label = option < 1000 ? option + " MB" : (option / 1000) + " GB"
                    return {
                        label: label,
                        value: option
                    }
                }
            }
        )
        setOptions(optionsWithLabel)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offerCtx.isLoaded, offerCtx.data])

    return (
        <>
            {defaultCapacity && (
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    openText={t('label.open')}
                    closeText={t('label.close')}
                    clearText={t('label.clear')}
                    options={options}
                    sx={{ width: 150 }}
                    value={value}
                    onChange={handleChange}
                    noOptionsText={t('offer.noResult')}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={t('capacity.choose')}
                            style={{
                                textAlign: "left",
                                color: "black"
                            }}
                        />
                    }
                />)
            }
        </>
    )
}

export default DataSelector